import { Component, forwardRef, inject, input } from '@angular/core';
import { AbstractFormControl } from '../abstract-form-control';
import { NbDateService } from '@nebular/theme';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { DateRangeObject } from '@models/date-range';
import { toValidDate } from '@/utils/date-utils';
import { endOfDay } from 'date-fns';

@Component({
  standalone: false,
  selector: 'wr-date-range-picker',
  templateUrl: './date-range-picker.component.html',
  styleUrls: ['./date-range-picker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DateRangePickerComponent),
      multi: true,
    },
  ],
})
export class DateRangePickerComponent extends AbstractFormControl<DateRangeObject> {

  private readonly dateService = inject<NbDateService<Date>>(NbDateService);

  readonly placeholder = input('Datum wählen');

  readonly showTodayButton = input(false);

  setRangeFilterToday(): void {
    const end = this.dateService.today();
    const start = this.dateService.addMonth(end, -1);
    this.updateValue({ start, end });
  }

  override writeValue(value: DateRangeObject | null | undefined): void {
    const start = toValidDate(value?.start);
    super.writeValue(start ? { start, end: toValidDate(value?.end) } : undefined);
  }

  updateValue(dateRange: DateRangeObject | undefined): void {
    if (!dateRange) {
      this.value = undefined;
      return;
    }
    const start = toValidDate(dateRange.start);
    const end = toValidDate(dateRange.end);
    this.value = start && { start, end: end && endOfDay(end) };
  }
}
